import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalModule } from 'ngx-bootstrap/modal';

import { ButtonModule } from '../button/button.module';
import { SearchModule } from '../search/search.module';
import { SpinnerModule } from '../spinner/spinner.module';
import { LoaderModule } from '../loader/loader.module';
import { ConfirmStatusChangesComponent } from './confirm-status-changes/confirm-status-changes.component';
import { ProductAdvancedSearchComponent } from './product-advanced-search/product-advanced-search.component';


@NgModule({
  imports: [
    CommonModule,
    ButtonModule,
    SearchModule,
    SpinnerModule,
    LoaderModule,
  ],
  declarations: [
    ConfirmStatusChangesComponent,
    ProductAdvancedSearchComponent,
  ],
  exports: [
    ConfirmStatusChangesComponent,
    ProductAdvancedSearchComponent,
  ],
  providers: []
})
export class ProductSharedModule {}
